import { render } from "./CommentAdd.vue?vue&type=template&id=3577a44b"
import script from "./CommentAdd.vue?vue&type=script&lang=js"
export * from "./CommentAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__